import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorText } from "../../lib/api";
import { Card, Field, inputCls } from "../../components/admin/Field";

const blank = { current: "", next: "", confirm: "" };

export default function ChangePassword() {
  const [f, setF] = useState(blank);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 10) return setError("New password needs at least 10 characters.");
    if (f.next !== f.confirm) return setError("The new passwords don't match.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      setF(blank);
      toast.success("Password changed. Use it next time you log in.");
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
    return undefined;
  };

  return (
    <form onSubmit={submit} data-testid="change-password-form" className="mx-auto max-w-lg space-y-6">
      <Link to="/admin" data-testid="password-back-link" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-[#0B192C]"><ArrowLeft className="h-4 w-4" />All pages</Link>
      <h1 className="font-display text-4xl">Change password</h1>
      <Card title="Your password">
        <Field label="Current password">
          <input data-testid="field-current-password" type="password" required autoComplete="current-password" value={f.current} onChange={set("current")} className={inputCls} />
        </Field>
        <Field label="New password" hint="At least 10 characters.">
          <input data-testid="field-new-password" type="password" required autoComplete="new-password" value={f.next} onChange={set("next")} className={inputCls} />
        </Field>
        <Field label="Repeat new password">
          <input data-testid="field-confirm-password" type="password" required autoComplete="new-password" value={f.confirm} onChange={set("confirm")} className={inputCls} />
        </Field>
        {error ? <p data-testid="change-password-error" className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p> : null}
        <button data-testid="change-password-submit" disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-full bg-[#C87D55] py-3.5 font-semibold text-[#0B192C] transition-colors duration-200 hover:bg-[#D4A373] disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Save new password
        </button>
      </Card>
    </form>
  );
}
